<template>
  <div class="content--sinoreg ordemServico p-4">
    <h4 class="ordemServico_title">
      Ordens de Serviços
    </h4>

    <OrdensServicoEdicao :prop-custas="custas"
                         :prop-ordem-servico="ordemServivo"
                         :prop-ordem-servico-sem-registro="true"
                         @deleteOS="deletarOS"
                         @imprimirRecibo="imprimirReciboOS"
                         @onBack="$router.push({ name: 'ordens_servicos' })"
                         @resultSaveOS="resultSaveOS"
                         @onGerarSelo="resultSaveOS"
                         @rechargeOS="rechargeOS" />

    <b-modal v-if="urlRecibo"
             visible
             hide-header
             hide-footer
             size="xl"
             @hide="urlRecibo = null">
      <object class="document-preview embed-responsive Recibo_modal"
              :data="urlRecibo"
              type="application/pdf">
        <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
      </object>

      <hr>

      <div class="text-right mt-2">
        <button class="btn btn-sm"
                @click="urlRecibo = null">
          Cancelar
        </button>

        <button class="btn btn-sm btn-secondary"
                @click="imprimir()">
          Imprimir
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import OrdensServicoEdicao from '@/components/SofiaRei/Resumo/OrdensServico/OrdensServicoEdicao'

  /* services */
  import SelosService from "@/services/Registros/SelosService"
  import CustasService from '@/services/Registros/CustasService'
  import RecibosService from '@/services/Registros/RecibosService'
  import OrdensServicoService from '@/services/Registros/OrdensServicoService'

  /* constants */
  import custas from '@/constants/custas'

  import moment from 'moment'
  import Swal from 'sweetalert2'
  import { mapGetters } from 'vuex'

  import { CriarSelo } from '../../common/selo'

  export default {
    name: 'VisualizaOrdemDeServico',
    components: {
      OrdensServicoEdicao
    },
    data () {
      return {
        ordemServivo: null,
        custas: [],
        urlRecibo: null,
        codCustas: []
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorioObj: 'auth/getCartorioObj'
      })
    },
    async beforeMount () {
      await this.init()
    },
    methods: {
      async init () {
        try {
          loader({ text: 'Aguarde...', active: true })
          this.ordemServivo = await OrdensServicoService.showOS(this.$route.params.id)

          const { data } = await CustasService.getCustas({
            cartorio_id: this.cartorioId,
            uf: 'SP',
            perPage: 100,
            os: 1,
            ativo: true
          })

          this.custas = data

          this.codCustas = custas.todos

          loader({ text: '', active: false })
        } catch (e) {
          loader({ text: '', active: false })

          console.error(e)
          this.$router.push('/pagina-nao-encontrada')
        }
      },
      async imprimirReciboOS (ordemDeServico) {
        if (!ordemDeServico) return

        const itensInvalidos = ordemDeServico.itens.filter(item => item.flag_cancelado)

        if (itensInvalidos.length > 0) {
          displayMessage('error', '', 'Os itens da ordem de serviço não são válidos para o recibo.')

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)

          return
        }

        const payload = {
          os: ordemDeServico,
          cartorio: this.cartorioObj,
          custas: ordemDeServico.itens,
          emolumentos: this.getEmolumentos(ordemDeServico.itens)
        }

        try {
          loader({ text: 'Aguarde...', active: true })

          this.urlRecibo = await RecibosService.reciboSemRegistro(payload)

          loader({ text: '', active: false })
        } catch (e) {
          loader({ text: '', active: false })

          displayMessage('error', '', 'Não foi possível imprimir o recibo da ordem de serviço. Tente novamente.')

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)
        }
      },
      getEmolumentos (itensOS = []) {
        let emolumentos = []
        let valor = null

        itensOS.forEach(item => {
          const { custa, averbacao, quantidade } = item

          custa.itens.forEach(custaItem => {
            const emolumentoIndex = emolumentos.findIndex(emolumento => emolumento.destino === custaItem.destino)

            if (averbacao > 0) {
              const custaAverbacaoItem = this.custas.find(custaIss => custaIss.codigo === 12)
              const destinatario = custaAverbacaoItem.itens.filter(custa => custa.destino == custaItem.destino)
              valor = (custaItem.valor * quantidade) + (destinatario[0].valor * averbacao)
            } else {
              valor = (custaItem.valor * quantidade)
            }            

            if (emolumentoIndex >= 0) {
              emolumentos[emolumentoIndex].valor += item.valor > 0 ? valor : 0
            } else {
              emolumentos.push({
                destino: custaItem.destino,
                valor: item.valor > 0 ? valor : 0
              })
            }
          })
        })

        emolumentos.push({
          destino: 'total',
          valor: emolumentos.map((e) => e.valor).reduce((a, b) => a + b, 0)
        })

        return emolumentos
      },
      imprimir () {
        window.open(this.urlRecibo)
      },
      deletarOS (ordemDeServico) {
        if (!ordemDeServico || !ordemDeServico.os) return

        const selos = this.verifySelos(ordemDeServico.os)

        if (selos > 0) {
          displayMessage('warning', 'Atenção!', 'Esta OS possui selos. Para excluir a OS, verifique os itens dentro dela.')

          return

        } else {
          displayMessage('question', 'Tem certeza que deseja excluir essa ordem de serviço?', '', {cancelButtonText: 'Não',confirmButtonText: 'Sim'}).then(async (res) => {
            if (res.value) {
              ordemDeServico.os = {
                ...ordemDeServico.os,
                cancelada: true,
                data_cancelamento: moment().format('YYYY-MM-DD')
              }

              try {
                loader({ text: 'Aguarde...', active: true })

                const payload = ordemDeServico.os

                // Verificamos se a OS tem algum selo
                payload.existeSelo = !!payload.itens.find(item => item.seloStatus)

                await OrdensServicoService.updateOS(payload, payload.ordem_servico_id)

                loader({ text: '', active: false })

                this.$router.push({ name: 'ordens_servicos' })
              } catch (e) {
                loader({ text: '', active: false })
                displayMessage('error', 'Erro!', e.response.data.message || 'Não foi possível excluir essa ordem de serviço. Tente novamente.')

                setTimeout(() => {
                  const btnCancel = document.querySelector('.swal2-cancel')

                  if (btnCancel) btnCancel.focus()
                }, 200)
              }
            }
          })

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-cancel')

            if (btnConfirm) btnConfirm.focus()
          }, 200)

        }
      },
      async resultSaveOS (resultSaveOS, papelSegurancaCusta) {

        // Só fazemos um retorno, pois na Edicao da OS já mostra o display message do erro
        if (!resultSaveOS) return

        const { itemOsIdComErroGerarSelo } = await CriarSelo(resultSaveOS, papelSegurancaCusta, this.cartorioObj)

        /**
         * Caso ocorra algum erro com a criação do selo, pegamos os ids dos itens da os e fazermos um destroy.
         * Fazemos isso para que o usuário possa editar a OS novamente, adicionar o item com o selo e tentar gerar novamente.
         * Se não o usuário vai precisar cancelar o item da OS ou até em alguns casos eles deletam a OS inteira e criam uma nova.
         */
        if (itemOsIdComErroGerarSelo.length) {
          for (const idItemOS of itemOsIdComErroGerarSelo) {
            try {
              await OrdensServicoService.destroyOsItem(idItemOS)
            } catch (e) {
              console.error(e)

              continue
            }
          }
        }

        loader({ text: '', active: false })

        const text = itemOsIdComErroGerarSelo.length ? 'Ocorreu erro ao gerar o(s) selo(s). Tente editar essa OS novamente ou entre em contato com o nosso suporte.' : 'Ordem de serviço salva com sucesso!'

        displayMessage('info', '', text).then(() => !!resultSaveOS.registro_id ? this.$router.push({ name: 'ordens_servicos' }) : this.init())

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)
      },
      verifySelos (os) {
        let selosQtd = 0

        os.itens.forEach(ordemServico => {
          if (ordemServico.seloItemOs && ordemServico.seloItemOs.length > 0 && !ordemServico.flag_cancelado) {
            ordemServico.seloItemOs.forEach(selo => {
              if (!!selo) {
                selosQtd++
              }
            })
          }
        })

        return selosQtd
      },
      rechargeOS () {
        return this.init()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/scss/_utilities/_exports";

  .ordemServico {
    &_title {
      background-color: $sinoreg-blue;
      color: $color-white;
      font-size: pxToRem(24);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }

    &_label {
      font-size: pxToRem(16);
    }
  }

  .Recibo {
    @media only screen and (max-width: 1600px) {
      &_modal {
        height: 33em !important;
        overflow: auto !important;
      }
    }

    @media only screen and (min-width: 1650px) {
      &_modal {
        height: 40em !important;
        overflow: auto !important;
      }
    }
  }
</style>